module.exports = __webpack_public_path__ + "images/bulk_estimate_bottom_btn_lable_8f636adc3901260cd309b2755a0a783d.png";